import { BenefitType } from "../enums/BenefitType";
import { UploadedDocument } from "../domain/UploadedDocument";
import { LeaveType } from "../enums/LeaveType";

export type PfmlFormValues = {
    leaveType: LeaveType,
    documents: UploadedDocument[],
}

export const defaultPfmlFormValues = {
    benefit: BenefitType.PAID_FAMILY_AND_MEDICAL_LEAVE,
    pfml: true,
    leaveType: '',
    documents: [{
        document: '',
        documentContent: '',
        documentType: ''
    }],
}